export const SUPPORT_SECTION_TRANSLATION_KEY =
  'support-section-translation-key';
